var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-input"},[_c('div',{staticClass:"icon-container"},[_vm._t("default")],2),_c('input',_vm._g(_vm._b({ref:"input",class:_vm.inputClass},'input',_vm.$attrs,false),_vm.$listeners))])}
var staticRenderFns = []

export { render, staticRenderFns }